import { useState } from "react";
import Swal from "sweetalert2";
import Modal from 'react-modal';
import './Query.css';

import { getApi, } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";

function Query() {
    const [docketNo, setDocketNo] = useState("");
    const [modalIsOpen1, setModalIsOpen1] = useState(false);
    const [trackingData, setTrackingData] = useState([]);
    const [showPod, setShowPod] = useState(false);
    const [selectedPod, setSelectedPod] = useState("");

    const downloadPod = async () => {

        if (!selectedPod) return;

        try {

            const response = await fetch(selectedPod);

            if (!response.ok) {
                throw new Error("Image not found");
            }

            const blob = await response.blob();

            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = blobUrl;

            link.download = selectedPod.split("/").pop();

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Download Failed",
                text: "Unable to download POD Image.",
            });

        }
    };
    const handleButtonClick = () => {
        setShowPod(!showPod);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!docketNo.trim()) {
            Swal.fire({
                icon: "warning",
                title: "Enter Docket No",
                text: "Please enter a Docket No.",
            });
            return;
        }

        try {
            const res = await getApi(`/Master/QuerywithProcess?DocketNo=${docketNo}&VendorLRNO=${docketNo}`);

            if (res.status === 1 && res.Data && res.Data.length > 0) {
                setTrackingData(res.Data);
                setModalIsOpen1(true);

                // Swal.fire({
                //     icon: "success",
                //     title: "Tracking Found",
                //     text: "Shipment details loaded successfully.",
                //     timer: 1500,
                //     showConfirmButton: false,
                // });
            } else {
                setTrackingData([]);

                Swal.fire({
                    icon: "warning",
                    title: "Not Found",
                    text: "Docket No or Vendor LR No not found.",
                });
            }
        } catch (error) {
            console.error(error);

            Swal.fire({
                icon: "error",
                title: "Error",
                text:
                    error.response?.data?.message ||
                    "Failed to fetch tracking details.",
            });
        }
    };

    return (
        <div className="body">
            <div className="container1">
                <form onSubmit={handleSubmit}>
                    <div className="fields2">
                        <div className="input-field1">
                            <label>Docket No / Vendor LRNO</label>
                            <input
                                type="text"
                                className="input"
                                placeholder="Enter Docket No / Vendor LRNO"
                                value={docketNo}
                                onChange={(e) => setDocketNo(e.target.value)}
                            />
                        </div>

                        <div
                            className="bottom-buttons"
                            style={{ marginTop: "23px", marginLeft: "10px" }}
                        >
                            <button className="ok-btn" type="submit">
                                Submit
                            </button>
                        </div>
                    </div>
                </form>
                <Modal
                    overlayClassName="custom-overlay"
                    isOpen={modalIsOpen1}
                    className="custom-modal"
                    contentLabel="Modal"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '95%',
                            overflowY: 'auto',     // ✅ enable vertical scroll
                            overflowX: 'auto',   // optional (clean UI)
                            zIndex: "99999",
                        },
                    }}
                >
                    <div className="custom-modal-content">
                        <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                            <header className="" style={{ width: "95%", textAlign: "center" }}>Tracking Details</header>
                            <button className="ok-btn " style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                onClick={() => {
                                    setModalIsOpen1(false);
                                    setDocketNo('');
                                }}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>

                        <div className="container2" style={{ padding: "10px" }}>

                            {trackingData.length > 0 ? (
                                trackingData.map((record, index) => (
                                    <>
                                        <div className="tables-wrapper" key={index} style={{ width: "100%" }}>

                                            {/* Table 1 */}
                                            <div className="table-container3">
                                                <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                                    <tbody>

                                                        <tr><td className="w-60">Branch Name</td><td>{record.BranchName || "-"}</td></tr>
                                                        <tr><td className="w-60">Book Date</td><td>{record.BookDate || "-"}</td></tr>
                                                        <tr><td className="w-60">Docket No</td><td>{record.DocketNo || "-"}</td></tr>
                                                        <tr><td className="w-60">Customer Name</td><td>{record.CustomerName || "-"}</td></tr>
                                                        <tr><td className="w-60">Mode</td><td>{record.ModeName || "-"}</td></tr>
                                                        <tr><td className="w-60">Origin</td><td>{record.OriginCity || "-"}</td></tr>
                                                        <tr><td className="w-60">Destination</td><td>{record.DestinationCity || "-"}</td></tr>
                                                        <tr><td className="w-60">Consignee Name</td><td>{record.Consignee_Name || "-"}</td></tr>
                                                        <tr><td className="w-60">Consignee Mobile</td><td>{record.Consignee_Mob || "-"}</td></tr>
                                                        <tr><td className="w-60">Address 1</td><td>{record.Consignee_Add1 || "-"}</td></tr>
                                                        <tr><td className="w-60">Address 2</td><td>{record.Consignee_Add2 || "-"}</td></tr>
                                                        <tr><td className="w-60">Address 3</td><td>{record.Consignee_Add3 || "-"}</td></tr>
                                                        <tr><td className="w-60">Address 4</td><td>{record.Consignee_Add4 || "-"}</td></tr>
                                                        <tr><td className="w-60">Consignee PIN</td><td>{record.Consignee_Pin || "-"}</td></tr>
                                                        <tr><td className="w-60">E-Way Bill</td><td>{record.EwayBill || "-"}</td></tr>
                                                        <tr><td className="w-60">Invoice No</td><td>{record.InvoiceNo || "-"}</td></tr>
                                                        <tr><td className="w-60">Qty</td><td>{record.Qty}</td></tr>
                                                        <tr><td className="w-60">Actual Weight</td><td>{record.ActualWt}</td></tr>
                                                        <tr><td className="w-60">Charged Weight</td><td>{record.ChargedWt}</td></tr>








                                                    </tbody>
                                                </table>

                                            </div>
                                            <div className="table-container3">
                                                <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                                    <tbody>

                                                        <tr><td className="w-60">Vendor Name</td><td>{record.Vendor_Name || "-"}</td></tr>
                                                        <tr><td className="w-60">Forwarding No</td><td>{record.VendorAwbNo || "-"}</td></tr>
                                                        <tr><td className="w-60">Delivey Boy</td><td>{record.Employee_code || "-"}</td></tr>
                                                        <tr><td className="w-60">Delivery Mobile</td><td>{record.Employee_Mobile || "-"}</td></tr>
                                                        <tr><td className="w-60">Area</td><td>{record.Area || "-"}</td></tr>
                                                        <tr><td className="w-60">Manifest No</td><td>{record.Manifest_No || "-"}</td></tr>
                                                        <tr><td className="w-60">Manifest Date</td><td>{record.Manifest_Dt || "-"}</td></tr>
                                                        <tr><td className="w-60">Manifest From</td><td>{record.From_Dest || "-"}</td></tr>
                                                        <tr><td className="w-60">Manifest Destination</td><td>{record.ManifestDestination || "-"}</td></tr>
                                                        <tr><td className="w-60">DRS No</td><td>{record.DrsNo || "-"}</td></tr>
                                                        <tr><td className="w-60">DRS Date</td><td>{record.DrsDate || "-"}</td></tr>
                                                        <tr><td className="w-60">Receiver Name</td><td>{record.RecvName || "-"}</td></tr>
                                                        <tr><td className="w-60">Receiver Mobile</td><td>{record.ReceivedMo || "-"}</td></tr>
                                                        <tr><td className="w-60">Expected Delivery</td><td>{record.ExptDateOfDelvDt || "-"}</td></tr>
                                                        <tr><td className="w-60">Delivery Status</td><td>{record.Status || "-"}</td></tr>
                                                        <tr><td className="w-60">Delivery Date</td><td>{record.DelvDT || "-"}</td></tr>
                                                        <tr><td className="w-60">Delivery Time</td><td>{record.DelvTime || "-"}</td></tr>
                                                        <tr><td className="w-60">Receiver Remark</td><td>{record.Recvremark || "-"}</td></tr>
                                                        <tr><td className="w-60">POD Image</td><td><span
                                                             style={{height:"20px",fontSize:"12px",cursor:"pointer",background:"blue",color:"white",padding:"3px 10px",borderRadius:"5px",fontWeight:"bold"}}
                                                            onClick={() => {
                                                                setSelectedPod(record.ImageLink);
                                                                setShowPod(true);
                                                            }}
                                                        >
                                                            View POD
                                                        </span></td></tr>
                                                        














                                                        
                                                    {/* <tr><td className="w-60">Vehicle No</td><td>{record.VehicleNo || "-"}</td></tr>  */}

                                                      






                                                        

                                                    </tbody>
                                                </table>

                                            </div>


                                            {/* Table 2 */}

                                        </div>
                                        <div className="table-container2">
                                            <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                                <thead className="background">
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Location</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {record.StatusEntry && record.StatusEntry.length > 0 ? (
                                                        record.StatusEntry.map((entry, idx) => (
                                                            <tr key={idx}>
                                                                <td>{entry.DelvDt}</td>
                                                                <td>{entry.DelvTime}</td>
                                                                <td>{entry.Destination_name}</td>
                                                                <td>{entry.Status}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={4}>No scans available.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>


                                ))
                            ) : (
                                <div>No shipment details available.</div>
                            )}

                        </div>
                    </div>
                </Modal >
                <Modal
                    isOpen={showPod}
                    onRequestClose={() => setShowPod(false)}
                    overlayClassName="pod-overlay"
                    className="pod-modal"
                >
                    <div className="pod-header">
                        <h5>📄 POD Image</h5>

                        <div>
                            <button
                                className="btn btn-success btn-sm"
                                onClick={downloadPod}
                            >
                                Download
                            </button>

                            <button
                                className="btn btn-danger btn-sm ms-2"
                                onClick={() => setShowPod(false)}
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    <div className="pod-body">
                        <img
                            src={selectedPod}
                            alt="POD"
                            className="pod-image"
                        />
                    </div>
                </Modal>


            </div>
        </div>
    );
}

export default Query;